export const activityCategories = [
    "visit",
    "call",
    "sms",
    "email",
    "event",
    "other",
];
export const activityCategoryLabels = {
    visit: "Visit",
    call: "Call",
    sms: "Text",
    email: "Email",
    event: "Event",
    other: "Other",
};
export const genericLogLabel = "Log activity";
export const activityCategoryLogLabels = {
    visit: "Log visit",
    call: "Log call",
    sms: "Log text",
    email: "Log email",
    event: "Log event",
    other: genericLogLabel,
};
export const activityCategoryForTouchpointType = {
    visit: "visit",
    call: "call",
    text: "sms",
    email: "email",
    note: "other",
    event: "other",
    gift: "other",
};
const categorySignals = [
    [
        "visit",
        /\bvisits?\b|\btours?\b|\btouring\b|\bmeetings?\b|\bmtg\b|\bmeet and greet\b|\bdrop[- ]?ins?\b|\bdrop[- ]?by\b|\bin[- ]person\b|\bin[- ]home\b|\bface to face\b/,
    ],
    ["call", /\bcalls?\b|\bphone\b/],
    ["email", /\bemails?\b/],
    ["sms", /\btexts?\b|\bsms\b/],
];
const arrangingSignal = /\bschedul\w*\b|\bcoordinat\w*\b|\bset up\b|\bbook(ed|ing)?\b/;
const categoryFromName = (name) => {
    if (arrangingSignal.test(name)) {
        return "other";
    }
    const matched = categorySignals.filter(([, signal]) => signal.test(name));
    return matched.length === 1 ? matched[0][0] : "other";
};
export const activityCategoryForTaskType = (name) => categoryFromName(name.toLowerCase());
const attendeeSupportedCategories = ["call", "visit"];
export const categorySupportsAttendees = (category) => attendeeSupportedCategories.includes(category);
//# sourceMappingURL=activity-category.js.map